import { render, staticRenderFns } from "./OffCanvas.vue?vue&type=template&id=4f1f9b69&"
import script from "./OffCanvas.vue?vue&type=script&lang=js&"
export * from "./OffCanvas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports